<template>
    <div class="feedback-step step-end">
        <div>
            <h2>Thank you for <br />your participation.</h2>
            <img src="/images/bahai-logo-small-white.svg" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "StepEnd",
        props: {
            surveyAlreadyCompleted: {
                type: Boolean
            },
            savedAnswers: {
                type: Array
            }
        },
        mounted () {
            if (!this.surveyAlreadyCompleted)
                this.$store.dispatch("setSurveyComplete", { id: this.$store.state.feedback.currentSurvey.id })
        },
        data() {
            return {
                lastAnswer: undefined
            }
        }
    }
</script>